<template lang="pug">
.c-article-editor
  .title {{ title }}
  page-loading(v-if="fetching")
  template(v-else)
    v-btn(v-if="enableCreate && !current"
      color="warning"
      @click="form = true") 新增文章
    template(v-if="form")
      v-btn(v-if="isList" color="warning" @click="reset") 返回
      new-article-editor(:type="type" :id="current")
    template(v-else="isList && !form")
      template(v-if="isList")
        page-loading(v-if="fetching")
        v-list
          template(v-for="item in items")
            v-card
              v-list-tile(@click="current = item.id,form = true")
                v-list-tile-content
                  v-list-tile-title {{ item.data.title }} {{ item.data.published ? '' : `(草稿)` }}
                  v-list-tile-subtitle {{ item.data.eventTime ? '活動日期：' + new Date(item.data.eventTime).toLocaleDateString() : '' }}
        pagination-loader(:queryRef="queryRef"
          :pagination="true"
          @update="items = $event")
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import uniqid from "uniqid";
import { storage } from "@/firebase";
import PageLoading from "@/components/core/PageLoading.vue";
import newArticleEditor from "@/components/cms/newArticleEditor.vue";
//
import FormFrame from "@/components/core/FormFrame.vue";
import PaginationLoader from "@/components/core/newPaginationLoader.vue";
import CoverEditor from "@/components/cms/CoverEditor.vue";
import TextEditor from "@/components/cms/TextEditor.vue";
import FilesEditor from "@/components/cms/FilesEditor.vue";
import ImagesEditor from "@/components/cms/ImagesEditor.vue";

export default {
  name: "ArticleEditor",
  mixins: [validationMixin],
  validations: {
    current: {
      title: { required }
    }
  },
  components: {
    PageLoading,
    PaginationLoader,
    newArticleEditor,
    //
    FormFrame,
    CoverEditor,
    TextEditor,
    FilesEditor,
    ImagesEditor
  },
  props: {
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    isList: {
      type: Boolean,
      default: false
    },
    docRef: {
      type: Object,
      default: null
    },
    queryRef: {
      type: Object,
      default: null
    },
    banner: {
      type: Boolean,
      default: true
    },
    files: {
      type: Boolean,
      default: true
    },
    images: {
      type: Boolean,
      default: true
    },
    enableCreate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defItem: {
        type: this.type,
        title: "",
        content: "",
        files: [],
        images: []
      },
      fetching: !this.isList,
      items: [],
      current: null,
      form: false
    };
  },
  created() {
    if (!this.isList) {
      this.fetchData();
    }
  },
  methods: {
    ...mapActions(["api"]),
    getErrors(field) {
      const errors = [];
      if (!this.$v.current[field].$dirty) return errors;

      !this.$v.current[field].required && errors.push("此欄必填");
      return errors;
    },
    async fetchData() {
      const doc = await this.docRef.get();
      const data = doc.data();
      this.$utils.set(data, "temp.id", doc.id);
      this.current = doc.id;
      this.fetching = false;
      this.form = true;
    },
    async submit() {
      const AppError = this.$utils.AppError;

      if (this.$v.$invalid) {
        this.$v.$touch();
        throw new AppError("請填妥必要資料");
      }

      if (!this.$refs.fileEditor.valid) {
        this.$refs.fileEditor.validate();
        throw new AppError("請填妥必要資料");
      }

      await this.uploadCover();
      await this.uploadImages();
      await this.uploadFiles();

      const id = this.$u.get(this.current, "temp.id");

      const data = this.$u.pick(this.current, [
        "title",
        "type",
        "cover",
        "content",
        "files",
        "images"
      ]);
      console.log(data);

      if (id) {
        return this.api({
          method: "put",
          url: `article/${id}`,
          data
        });
      } else {
        return this.api({
          method: "post",
          url: `article`,
          data
        });
      }
    },
    async uploadCover() {
      const img = this.$utils.get(this.current, "cover.temp.file");
      if (!img) return;

      const strageRef = storage.ref();
      const filename = uniqid();
      const ext = img.name.replace(/.*\./g, ".");
      const filepath = `images/articles/${filename}${ext}`;
      const ref = strageRef.child(filepath);

      await ref.put(img);
      this.current.cover = Object.assign({}, this.current.cover, {
        name: filepath
      });
    },
    async uploadImages() {
      const strageRef = storage.ref();
      const uploadList = [];

      this.current.images.forEach(image => {
        if (!this.$u.get(image, "temp.file")) return;

        const filename = uniqid();
        const ext = image.temp.file.name.replace(/.*\./g, ".");
        const filepath = `images/articles/${filename}${ext}`;
        const ref = strageRef.child(filepath);

        uploadList.push(
          ref.put(image.temp.file).then(() => {
            image.name = filepath;
            delete image.temp;
          })
        );
      });

      await Promise.all(uploadList);
    },
    async uploadFiles() {
      const strageRef = storage.ref();
      const uploadList = [];

      this.current.files.forEach(file => {
        if (file.name) return;

        const filename = uniqid();
        const ext = file.file.name.replace(/.*\./g, ".");
        const size = file.file.size;
        const filepath = `files/articles/${filename}${ext}`;
        const ref = strageRef.child(filepath);

        uploadList.push(
          ref.put(file.file).then(() => {
            file.name = filepath;
            file.size = size;
            file.ext = ext;
            delete file.file;
          })
        );
      });

      await Promise.all(uploadList);
    },
    reset() {
      this.current = null;
      this.form = false;
    }
  }
};
</script>
